<div
  [id]="zipYiElement.GiftCardDenominationSelect"
  class="zip-select-option"
  [ngClass]="[
    !selectOptionService.isValidData ? 'is-error' : '',
    checkoutStateService.isCheckoutBtnTriggered ? 'is-disable' : '',
    hideDenominations ? 'is-hidden' : ''
  ]"
>
  <div class="select-option-wrapper">
    <div class="select-option-label">
      <span>
        {{ titleSelectOption }}
      </span>
    </div>
    <div class="select-option-selected-value">
      <span *ngIf="dataSelected !== ''">
        {{ dataSelected !== 'custom' ? '$' + dataSelected : 'Custom' }}
      </span>
      <span *ngIf="dataSelected == ''"> Select option </span>
    </div>
    <div class="overlay-select" (click)="toggleDropdown($event)"></div>
    <div class="select-option-dropdown" (mouseleave)="closeDropdown($event)">
      <div
        class="option-item"
        *ngFor="let dataOption of selectOptionService.dataOptions"
        (click)="doSelectValueOption($event, dataOption)"
        [ngClass]="{
          'is-disable': dataOption.stock !== 'IN_STOCK',
          'is-selected': dataOption.isSelected
        }"
      >
        {{ dataOption.price !== 'custom' ? '$' + dataOption.price : 'Custom' }}
        <span *ngIf="dataOption.stock !== 'IN_STOCK'"> Back in stock soon! </span>
      </div>
    </div>
  </div>
</div>

<div
  class="zip-row-input"
  *ngIf="dataSelected == 'custom'"
  [ngClass]="{ 'is-error': !selectOptionService.isValidCustomAmount, 'is-valid': isFocused }"
>
  <div class="row-input-wrapper">
    <div class="input-label">
      <span> Custom amount </span>
    </div>
    <div class="input-wrapper">
      <input
        [id]="zipYiElement.GiftCardCustomDenominationInput"
        type="text"
        [(ngModel)]="customAmountValue"
        (focus)="selectOptionService.handleFocusInput($event); handleFocusInputCustomAmount($event)"
        (blur)="
          selectOptionService.handleBlurInput($event); handleOutFocusInputCustomAmount($event)
        "
        (input)="handleInputChangeCustomAmount($event)"
        [OnlyNumber]="true"
      />
    </div>
  </div>
  <div class="row-input-notice">
    <span [ngClass]="{ 'is-error': !selectOptionService.isValidCustomAmount }">
      Amount must be between ${{ minCustomPrice }} and ${{ maxCustomPrice }}
    </span>
  </div>
</div>

<div class="zip-select-option-error is-error" *ngIf="!selectOptionService.isValidData">
  Please enter amount of gift card!
</div>
